import React, { Component } from "react";
import Translation from "../services/translation.service";
import ProtectionChannel from "../views/protection/protection-channel.component";
// import Title from "../views/shared/title.component";
import SDBanner from '../assets/img/sim_deactivation_banner.png';
import Storage from "../services/storage.service";
import StorefrontTitle from "../views/shared/storefront-title.component";

class protection_channel extends Component {
    prefix = "scr_protection_channel";
    
    state = {
        status: ""
    };

    handleWindowBeforeUnload = (e) => {
        e.preventDefault();
        Storage.clear('protection_channel_redirect');
        Storage.clear('protection_channel_redirect_url');
        Storage.clear('protection_channel_step');
        e.returnValue = true;
    }

    constructor(props) {
        super(props);
        //Cleanup sim_deactivation redirect localStorage
        window.removeEventListener("beforeunload", this.handleWindowBeforeUnload);
    }

    componentWillUnmount() {
        // Clear sim deactivation localStorage identifier for redirect
        Storage.clear('protection_channel_redirect');
        Storage.clear('protection_channel_redirect_url');
        Storage.clear('protection_channel_step');
    }
    render() {
        return (
            <div className="container page protection-channel">
                {this.state.status !== "failure" && (
                    <div className="protection-channel-header">
                        <StorefrontTitle
                            title={
                                `${Translation.keys[this.prefix + "_protection"]} 
                                 ${Translation.keys[this.prefix + "_channel"]}`
                            }
                        />
                        <div>
                            <img src={SDBanner} alt="" />
                        </div>
                    </div>
                )}
                <ProtectionChannel 
                    history={this.props.history}
                    status={this.state.status}
                    setStatus={(status) => this.setState({ status })}
                />
            </div>
        );
    }
};

export default protection_channel;